<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>{{ pageTitle }} for {{ dateText }}</h4>
            <h6>Manage {{ pageTitle }}</h6>
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
               @click="toggleCollapse(collapseHeader)">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn d-flex gap-1">
          <a @click="saveDevotion()" href="javascript:void(0);" class="btn btn-added">
            <vue-feather type="plus-circle"
                         class="me-2"></vue-feather>
            Save</a>

          <router-link style="color: var(--PRIMARY-COLOR) !important;" :to="cancelRoute"
                       class="btn btn-added bg-white">
            <vue-feather type="x" class="me-2"></vue-feather>
            Cancel
          </router-link>
        </div>
      </div>
      <div class="card">
        <div class="card-body pb-0">
          <div class="d-flex">
            <a class="btn btn-added my-3 mx-0" @click="pasteDevotion()" v-if="devotionStore.copiedDevotion">
              <vue-feather type="clipboard" class="me-2"></vue-feather>
              Paste Copied Devotion
            </a>
          </div>

          <TitleSection
              :devotion="devotion"
              :categories="categories"
              :page-title="pageTitle"
              :show-note="showNote"
          />

          <!-- Reference-->
          <ReferenceSection
              :devotion="devotion"
              :action="action"
              :show-note="showNote"
              :page-title="pageTitle"
              :filter-option="filterOption"
              @addDevotionReference="addDevotionReference"
              @removeDevotionReference="removeDevotionReference"
          />
          <!-- /Reference -->

          <!-- Image thumbnail-->

          <div class="d-flex my-2" style="cursor: pointer;">
            <a-image :width="0" :style="{ display: 'none' }" :preview="{
              visible,
              onVisibleChange: setVisible,
            }" :src="imagePreviewUrl"/>

            <div v-if="imagePreviewUrl" class="image-container col-12 rounded"
                 @mouseover="showOverlayMain = true" @mouseleave="showOverlayMain = false">
              <img :src="imagePreviewUrl" alt="Preview"/>
              <div v-if="showOverlayMain" class="overlay">
                <button @click="deleteImage" class="delete-btn">
                  <vue-feather type="trash-2"></vue-feather>
                </button>
                <button @click="openThumbnail(imagePreviewUrl)" class="zoom-btn">
                  <vue-feather type="zoom-in"></vue-feather>
                </button>
              </div>
            </div>

            <div class="file-upload" v-else @click="openModal(false)">

                <span role="img" aria-label="plus" class="anticon anticon-plus">
                  <svg focusable="false" data-icon="plus"
                       width="1em" height="1em"
                       fill="currentColor"
                       aria-hidden="true"
                       viewBox="64 64 896 896">
                  <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                  <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                </svg><!----></span>
              <div class="file-upload-text">Upload</div>
            </div>
          </div>

          <!-- /Image thumbnail-->


          <Summernote :initialContent="devotion.content" v-model:content="devotion.content"
                      placeholder="Devotional Body" id="editor" v-if="showNote">
          </Summernote>

          <!-- Additional text -->
          <AdditionalText
              :devotion="devotion"
              :action="action"
              :show-note="showNote"
              :filter-option="filterOption"
              @addAdditionalText="addReference"
              @removeAdditionalText="removeReference"
          />
          <!-- /End of Additional Text -->

          <!-- Prayers -->

          <PrayerSection
              :devotion="devotion"
              :action="action"
              :show-note="showNote"
              @addPrayer="addPrayer"
              @removePrayer="removePrayer"
          />
          <!-- /Prayers -->

          <!-- Devotion Extras -->
          <ExtrasSection
              :devotion="devotion"
              :show-note="showNote"
              @addExtra="addExtra"
              @removeExtra="removeExtra"
              @addPoint="addPoint"
              @removePoint="removePoint"
          />

          <!-- /Devotion Extras -->

          <!-- Photo Quotes -->
          <div class="card" v-if="showNote">
            <div class="card-body">
              <div>
                <h5>
                  Photo Quotes
                </h5>
              </div>

              <!-- Thumbnails -->
              <div class="my-2">
                <a-image :width="0" :style="{ display: 'none' }" :preview="{
                  visible,
                  onVisibleChange: setThumbnailVisible,
                }" :src="previewingImage"/>

                <div v-if="thumbnailPreviewUrls.length > 0" class="d-flex gap-3">
                  <div v-for="(image, index) in thumbnailPreviewUrls" :key="index" class="image-container rounded"
                       @mouseover="hoverIndex = index"
                       @mouseleave="hoverIndex = null">
                    <img :src="image.url || image" alt="Preview"/>
                    <div v-if="hoverIndex === index" class="overlay">
                      <button @click="deleteThumbnail(image, index)" class="delete-btn">
                        <vue-feather type="trash-2"></vue-feather>
                      </button>
                      <button @click="openThumbnail(image.url || image)" class="zoom-btn">
                        <vue-feather type="zoom-in"></vue-feather>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="file-upload my-4" @click="openModal(true)">
                  <!--                  <input type="file" @change="previewThumbnails" multiple/>-->

                  <span role="img" aria-label="plus" class="anticon anticon-plus">
                    <svg focusable="false"
                         data-icon="plus" width="1em"
                         height="1em" fill="currentColor"
                         aria-hidden="true"
                         viewBox="64 64 896 896">
                      <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                      <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                    </svg><!----></span>
                  <div class="file-upload-text">Upload</div>
                </div>

                <!-- </div> -->
              </div>
              <!-- End of thumbnails -->

            </div>
          </div>

          <!-- /Photo Quotes -->
        </div>
      </div>
    </div>
  </div>

  <MediaModal
      ref="mediaModal"
      :media="media"
      :select-multiple="selectMultiple"
      :selected-media="selectedMedia"
      @selected="handleMediaSelected"
  />

  <!-- </div>
  </div> -->
</template>

<script setup>
import Summernote from "@/components/summernote.vue";
import TitleSection from "@/views/pages/devotion/components/TitleSection.vue";
import ReferenceSection from "@/views/pages/devotion/components/ReferenceSection.vue";
import AdditionalText from "@/views/pages/devotion/components/AdditionalText.vue";
import ExtrasSection from "@/views/pages/devotion/components/ExtrasSection.vue";
import PrayerSection from "@/views/pages/devotion/components/PrayerSection.vue";
import {useDevotionStore} from "@/store/devotionStore";
import {downloadImage, formatDate} from "@/utils";
import {computed, onMounted, ref, nextTick} from "vue";
import {useRoute, useRouter} from "vue-router";
import {toggleCollapse} from "@/utils/components";
import Swal from "sweetalert2";
import {decodeUrlData} from "./utils/data";
import {devotionTypes} from "@/constants/enum";
import {useWordStore} from "@/store/wordStore";
import {useMediaStore} from "@/store/mediaStore";
import MediaModal from "@/views/pages/modals/mediaModal.vue";

// html ref
const collapseHeader = ref(null);

const showOverlayMain = ref(false);

const route = useRoute();
const router = useRouter();
// store
const devotionStore = useDevotionStore();
const wordStore = useWordStore();
const mediaStore = useMediaStore();
const selectMultiple = ref(false)
const selectedMedia = ref([]);

// data
const media = computed(() => mediaStore.media);
const cancelRoute = {name: "devotion-list"};
const action = ref(null);
const showNote = computed(
    () => devotion.value.type == devotionTypes.dailyDevotion
);
const categories = computed(() =>
    devotionStore.devotionCategories.map((category) => ({
      id: category.id,
      text: category.name,
    }))
);

const devotion = ref({
  title: "",
  content: "",
  category_id: null,
  date: null,
  type: null,
  thumbnail: null,
  post_time: null,
  author: null,
  media_item_id: "",
  reference: {
    title: null,
    bible_reference: null,
    body: null,
  },
  devotion_reference: [
    {
      book: null,
      chapter: null,
      from_verse: null,
      to_verse: null
    }
  ],
  additional_text: [
    {
      title: null,
      book: null,
      chapter: null,
      from_verse: null,
      to_verse: null,
      body: null
    }
  ],
  prayers: [{text: ""}],
  extras: [
    {
      title: '',
      points: []
    }
  ],
  thumbnails: [],
  photo_quote_media_items: []

});

const mediaModal = ref(null);

// Duplicate additional text column
function addDevotionReference() {
  devotion.value.devotion_reference.push({
    book: null,
    chapter: null,
    from_verse: null,
    to_verse: null,
  });
}

function removeDevotionReference(index) {
  if (devotion.value.devotion_reference.length > 1) {
    devotion.value.devotion_reference.splice(index, 1);
  }
}

function addReference() {
  devotion.value.additional_text.push({
    title: null,
    bible_verse: null,
    body: null,
  });
}

function removeReference(index) {
  if (devotion.value.additional_text.length > 1) {
    devotion.value.additional_text.splice(index, 1);
  }
}

function addExtra() {
  devotion.value.extras.push({
    'title': null,
    'points': []
  })
}

function removeExtra(index) {
  devotion.value.extras.splice(index, 1);
}

function addPoint(index) {
  devotion.value.extras[index].points.push("");
}

function removePoint(extraIndex, pointIndex) {
  devotion.value.extras[extraIndex].points.splice(pointIndex, 1);
}

function addPrayer() {
  devotion.value.prayers.push({
    text: ""
  });
}

function removePrayer(index) {
  if (devotion.value.prayers.length > 1) {
    devotion.value.prayers.splice(index, 1);
  }
}

// End of duplicate additional text column

const pageTitle = computed(() => {
  if (devotion.value.type == devotionTypes.dailyDevotion) {
    return "Devotional";
  }
  return devotion.value.type;
});
const imagePreviewUrl = ref(null);
const thumbnailPreviewUrls = ref([]);
const selectedFiles = ref([]);

const showOverlay = ref(false);

const dateText = computed(() => formatDate(devotion.value.date));

// methods

const visible = ref(false);
const previewingImage = ref("");
const hoverIndex = ref(null);

const setVisible = (value) => {
  visible.value = value;
};

const setThumbnailVisible = (value) => {
  visible.value = value;
};

function saveDevotion() {
  const redirectRouteName =
      devotion.value.type == devotionTypes.dailyDevotion
          ? "devotion-list"
          : "word-of-day";
  switch (action.value) {
    case "add":
      // devotionStore.addDevotion(devotion.value).then((response) => {
      devotionStore.addDevotion(devotion.value).then((response) => {
        if (response) {
          router.push({name: redirectRouteName});
        }
      });
      break;
    case "edit":
      console.log(devotion.value);
      devotionStore
          .updateDevotion(devotion.value.id, devotion.value)
          .then((response) => {
            if (response) {
              router.push({name: redirectRouteName});
            }
          });
      break;
  }
}

function previewImage(event) {
  const file = event.target.files[0];
  if (file) {
    devotion.value.thumbnail = file;
    log(file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      imagePreviewUrl.value = reader.result;
    };
  }
}

function deleteImage() {
  imagePreviewUrl.value = "";
  devotion.value.thumbnail = null;
  devotion.value.media_item_id = "";
}

function handleMediaSelected(selected) {
  if (!selectMultiple.value) {
    imagePreviewUrl.value = selected[0]?.url || '';
    devotion.value.media_item_id = selected[0]?.id || '';
  } else {
    selected.forEach(media => {
      const exists = devotion.value.photo_quote_media_items.includes(media.id);
      if (!exists) {
        devotion.value.photo_quote_media_items.push(media.id);
        thumbnailPreviewUrls.value.push({ id: media.id, url: media.url });
      }
    });
  }
}

function handleFileUpload(event) {
  const file = event.target.files[0];
  if (file) {
    devotion.value.file = file;
  }
}

function previewThumbnails(event) {
  const files = Array.from(event.target.files);
  files.forEach((file) => {
    selectedFiles.value.push(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      // normalize to object with url
      thumbnailPreviewUrls.value.push({
        id: null,          // no ID yet
        url: e.target.result
      });
    };
    reader.readAsDataURL(file);
  });

  devotion.value.thumbnails = selectedFiles.value;
}

async function deleteThumbnail(image, index) {
  // if (image.url) {
  //   await devotionStore.deleteDevotionPhotoQuote(image.id);
  // }

  if (image.id) {
    // Remove the media ID from the array
        devotion.value.photo_quote_media_items =
        devotion.value.photo_quote_media_items.filter(id => id !== image.id);
  } else {
    // If it was uploaded file (before saving)
    selectedFiles.value.splice(index, 1);
    devotion.value.photo_quote_media_items = [...selectedFiles.value];
  }


  selectedFiles.value.splice(index, 1);
  thumbnailPreviewUrls.value.splice(index, 1);
}

function openThumbnail(image) {
  previewingImage.value = image;
  setThumbnailVisible(true);
}

function openModal(isMultiple) {
  selectMultiple.value = isMultiple;
  let preSelected = [];
  if (!isMultiple) {
    if (imagePreviewUrl.value && devotion.value.media_item_id) {
      preSelected = [{id: devotion.value.media_item_id, url: imagePreviewUrl.value}];
      this.selectedMedia = preSelected;
    }
    $("#mediaModal").modal("show");
  } else if (isMultiple) {
    if (thumbnailPreviewUrls.value.length > 0) {
      preSelected = thumbnailPreviewUrls.value.map((item, idx) => ({
        id: item.id || `temp-${idx}`,
        url: item.url
      }));
      this.selectedMedia = preSelected;
    }
    $("#mediaModal").modal("show");
  }
}

/**
 * Load Devotional or Word Of Day Details
 * @param currentDevotion {Object} Devotional or Word Of Day Details
 */
function loadData(currentDevotion, skipDate = false) {

  devotion.value.id = currentDevotion.id;
  devotion.value.title = currentDevotion.title;
  devotion.value.content = currentDevotion.content;
  devotion.value.category_id = currentDevotion.category.id;
  devotion.value.author = currentDevotion.author;

  if (currentDevotion.reference) {
    devotion.value.reference.title = currentDevotion.reference.title;
    devotion.value.reference.bible_reference = currentDevotion.reference.bible_quotation;
    devotion.value.reference.body = currentDevotion.reference.content;
  }

  if (currentDevotion.reference) {
    devotion.value.reference = {
      title: currentDevotion.reference.title,
      bible_reference: currentDevotion.reference.bible_quotation,
      body: currentDevotion.reference.content
    };
  } else {
    devotion.value.reference = null; // keep it null
  }

  if (Array.isArray(currentDevotion.new_reference) && currentDevotion.new_reference.length > 0) {
    devotion.value.devotion_reference = currentDevotion.new_reference.map(item => ({
      book: item.book || null,
      chapter: item.chapter || null,
      from_verse: item.verse || null,
      to_verse: item.to || null,
    }));
  } else {
    // If no data, keep at least one blank row
    devotion.value.devotion_reference = [
      {book: null, chapter: null, from_verse: null, to_verse: null}
    ];
  }

  // ✅ Load additional_text (array)
  if (Array.isArray(currentDevotion.additional_text) && currentDevotion.additional_text.length > 0) {
    // Map data to ensure keys match your front-end
    devotion.value.additional_text = currentDevotion.additional_text.map(item => ({
      title: item.title || null,
      bible_verse: item.bible_quotation || null,
      book: item.decoded_verse.book || null,
      chapter: item.decoded_verse.chapter || null,
      from_verse: item.decoded_verse.verse || null,
      to_verse: item.decoded_verse.to || null,
      body: item.content || null
    }));
  } else {
    // If no data, keep at least one blank row
    devotion.value.additional_text = [
      {title: null, bible_verse: null, body: null}
    ];
  }

  // ✅ Load prayers (array)
  if (Array.isArray(currentDevotion.prayers) && currentDevotion.prayers.length > 0) {
    // Map data to ensure keys match your front-end
    devotion.value.prayers = currentDevotion.prayers.map(item => ({
      text: item || null,
    }));
  } else {
    devotion.value.prayers = [];
  }

  if (Array.isArray(currentDevotion.extras) && currentDevotion.extras.length > 0) {
    devotion.value.extras = currentDevotion.extras.map(item => ({
      title: item.title || '',
      points: Array.isArray(item.points) ? item.points.map(point => point || '') : []
    }));
  } else {
    devotion.value.extras = [
      {
        title: '',
        points: []
      }
    ]
  }
  if (currentDevotion.thumbnail) {
    imagePreviewUrl.value = currentDevotion.thumbnail;
    // devotion.value.media_item_id = currentDevotion.media.id;
  }
  if (currentDevotion.media) {
    // imagePreviewUrl.value = currentDevotion.media.url;
    devotion.value.media_item_id = currentDevotion.media.id;
  }
  // imagePreviewUrl.value = currentDevotion.thumbnail;

  // Load Photo Quotes
  if(Array.isArray(currentDevotion.new_photo_quotes) && currentDevotion.new_photo_quotes.length > 0) {
    devotion.value.photo_quote_media_items = currentDevotion.new_photo_quotes.map(item => item.id);

    // Filter out empty URLs
    thumbnailPreviewUrls.value = currentDevotion.new_photo_quotes
        .filter(item => item.url) // only items with url
        .map(item => ({
          id: item.id,
          url: item.url
        }));
  } else if (Array.isArray(currentDevotion.admin_thumbnails) && currentDevotion.admin_thumbnails.length > 0) {
    devotion.value.thumbnails = currentDevotion.admin_thumbnails
        .filter(item => item.url) // only items with url
        .map(item => item); // keep as-is for preview

    thumbnailPreviewUrls.value = currentDevotion.admin_thumbnails
        .filter(item => item.url)
        .map(item => item);
  } else {
    devotion.value.thumbnails = [];
    thumbnailPreviewUrls.value = [];
  }

  if (!skipDate) {
    devotion.value.post_time = currentDevotion.post_time;
    devotion.value.date = currentDevotion.date;
  }
}

/**
 * Load the Word of day
 * @param date {Date}
 */
async function loadWord(date, dateText) {
  /** @var {Array} */
  const words = wordStore.loadWordByMonth(date.getFullYear(), date.getMonth());
  let wordOfDay = null;
  if (words?.length > 0) {
    wordOfDay = words.find((word) => word.date == dateText).devotion; // find devotion with date
  } else {
    wordOfDay = await devotionStore.fetchDevotionByDate(
        dateText,
        devotionTypes.word
    ); // load from server
  }
  return wordOfDay;
}

/**
 * load the Devotional
 * @param date {Date}
 */
async function loadDevotion(date, dateText) {
  // load the devotion
  /** @var {Array} */
  const devotions = devotionStore.loadDevotionsByMonth(
      date.getFullYear(),
      date.getMonth()
  );
  let currentDevotion = null;
  if (devotions?.length > 0) {
    currentDevotion = devotions.find((devotion) => devotion.date == dateText)
        .devotion; // find devotion with date
  } else {
    currentDevotion = await devotionStore.fetchDevotionByDate(dateText); // load from server
  }

  return currentDevotion;
}

/**
 * Load the data and method required for the specified action
 */
async function initDevotion() {
  action.value = route.params["action"];
  const decodedData = decodeUrlData(route.params["encodedData"]);

  const dateText = decodedData.date;
  const date = new Date(dateText);
  devotion.value.date = dateText;
  devotion.value.type = decodedData.type;

  switch (action.value) {
    case "edit":
      let data = {};
      if (decodedData.type == devotionTypes.dailyDevotion) {
        data = await loadDevotion(date, dateText);
      } else if (decodedData.type == devotionTypes.word) {
        data = await loadWord(date, dateText);
      }
      loadData(data);
      break;
  }
}

async function pasteDevotion() {
  if (!devotionStore.copiedDevotion) {
    copiedDevotion = await navigator.clipboard.readText();
  } else {
    const copiedDevotion = devotionStore.copiedDevotion;
    loadData(copiedDevotion, true);
    devotion.value.thumbnail = await downloadImage(copiedDevotion.thumbnail);
  }
}

onMounted(async () => {
  await devotionStore.fetchDevotionCategories();
  await mediaStore.fetchMedia();

  try {
    await initDevotion();
  } catch (e) {
    log(e);
    Swal.fire("Unable to Parse Token", "", "warning");
    router.back();
  }
});
</script>

<style>
.ant-pagination {
  display: flex !important;
  align-items: center !important;
  justify-content: end !important;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-container {
  position: relative;
  height: 150px;
  overflow: hidden;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.overlay button {
  background: transparent;
  border: none;
  color: white;
  font-size: 16px;
  margin: 0 10px;
  cursor: pointer;
}

.overlay button:hover {
  text-decoration: underline;
}

.image-container:hover .overlay {
  opacity: 1;
}

.file-upload {
  width: 102px;
  height: 102px;
  margin-inline-end: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: center;
  justify-content: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.02);
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  transition: border-color 0.3s;
  position: relative;
  flex-direction: column;
}

.file-upload input[type="file"] {
  cursor: pointer;
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
}
</style>
